import * as React from 'react';

import Row from 'components/Row';
import Text from 'components/Text';
import Image from 'components/Image';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import CenteredContainer from 'components/CenteredContainer';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';

export default function MergingUserPoller() {
  return (
    <CenteredContainer>
      <Box size="small">
        <BoxBody>
          <Row>
            <Image src={require('assets/images/merging-user.svg')} />
          </Row>
          <Row>
            <Text element="p">Merging your accounts</Text>
          </Row>
          <CenteredLoadingIndicator />
        </BoxBody>
      </Box>
    </CenteredContainer>
  );
}
